<button #buttonTextArrowMenu
  [class]="'common-button__text-border-with-arrow common-button__text-border-with-arrow--light common-button__text-border-with-arrow--' + item.typeButton"
  [ngClass]="{'common-button__text-border-with-arrow--open': item.openDropdown}"
  [ngStyle]="{'width': item.fixedWidth?buttonWithTextMenu.widthButton:'auto',
    'max-width': buttonWithTextMenu.widthButton}"
  [disabled]="disabled"
  (click)="toggleFilter($event)">
  <span-tooltip [class]="'common-dropdown-overlay__text-selected-option common-dropdown-overlay__text-selected-option--' + item.typeButton"
    [text]="buttonWithTextMenu.textButton"></span-tooltip>
  <i [ngClass]="{'lf-icon-angle-up': overlayPanelTextArrowMenu.overlayVisible,
      'lf-icon-angle-down': !overlayPanelTextArrowMenu.overlayVisible,
      'common-icon__md': !buttonWithTextMenu.smallButton,
      'common-icon__sm': buttonWithTextMenu.smallButton}"></i>
</button>
<p-overlayPanel
  #overlayPanelTextArrowMenu
  (onShow)="item.openDropdown = true"
  (onHide)="item.openDropdown = false"
  styleClass="common-dropdown-overlay__container-with-arrow">
  <ng-template pTemplate="content">
    <div class="common-dropdown-overlay__inner-container"
      [ngStyle]="{'width': buttonTextArrowMenuElement.nativeElement?.offsetWidth+'px'}">
      @if(item.withSearch && list?.length > 5){
        <div class="common-search__container-tonal">
          <div class="common-search__container-input-text">
            <input
              type="search"
              class="common-search__input-text"
              pAutoFocus
              [autofocus]="true"
              [(ngModel)]="buttonWithTextMenu.inputFilter"
              placeholder="{{'common.search-item' | afTranslate}}">
          </div>
          <div class="common-search__block-button-search">
            @if(buttonWithTextMenu.inputFilter){
              <button class="common-button__icon-xs-noborder"
                (click)="resetFilter()">
                <i class="lf-icon-close-thick common-icon__sm"></i>
              </button>
            }
            <div class="h-[22px]"
              ngClass="{{buttonWithTextMenu.inputFilter?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'}}">
            </div>
            <i class="lf-icon-search common-icon__md"
              ngClass="{{!buttonWithTextMenu.inputFilter ? 'common-search__icon-search-disabled' : 'common-search__icon-search-enabled'}}">
            </i>
          </div>
        </div>
      }
      <div class="common-dropdown__items-container">
        @for (optionAction of list | byWord:buttonWithTextMenu.inputFilter:['name'] | afOrderBy:[item.orderBy]:false; track $index) {
          <!-- @if(item.listWithIcon && optionAction.icon){
            <i class="lf-icon-user common-icon__md"></i>
          } -->
          <button class="common-dropdown-list__si-button"
            (click)="launchAction(optionAction.action, optionAction, $event)"
            [disabled]="optionAction.disabled">
            <span-tooltip class="common-dropdown-list__si-text-container"
              [text]="optionAction[item.keyName]"
              [tooltipPosition]="'top'"
              [multiline]="multiline"></span-tooltip>
          </button>
        }@empty {
          <span class="common-empty-state__searched-text"
            [afTranslate]="'common.without-results'">
            _Sin resultados
          </span>
        }
      </div>
    </div>
  </ng-template>
</p-overlayPanel>
